
import React from 'react';  
import classes from './modal.module.scss';
import { IoMdClose } from "react-icons/io";

interface ModalProps {  
  isOpen: boolean;  
  onClose: () => void;  
  children: React.ReactNode;
  background?: string;
}  

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, background }) => {  
  if (!isOpen) return null;  

  return (  
    <div className={classes.modalOverlay}>  
      <div className={classes.modalContent}  style={{backgroundColor: background}}>  
        <button className={classes.closeButton} onClick={onClose}><IoMdClose /></button>  
        {children}
      </div>  
    </div>  
  );  
};  

export default Modal;  